import { type App } from "vue";
import ClickOutside from "./ClickOutside";
import Closable from "./Closable";
import ButtonActiveToggle from "./ButtonActiveToggle";
import Hover from "./Hover";
import HoverPrefetchUrl from "./HoverPrefetchUrl";
import StickyElement from "./StickyElement";
import AutoResizeTextarea from "./AutoResizeTextarea";

// Vue 3 normalizes directive lookup, but explicit camelCase keys avoid edge cases
// where PascalCase registrations fail to resolve from kebab-case template usage.
/**
 * Registers all global Vue directives on the app instance.
 */
export const registerDirectives = (app: App): void => {
  app.directive("clickOutside", ClickOutside);
  app.directive("closable", Closable);
  app.directive("buttonActiveToggle", ButtonActiveToggle);
  app.directive("hover", Hover);
  app.directive("hoverPrefetchUrl", HoverPrefetchUrl);
  app.directive("stickyElement", StickyElement);
  app.directive("autoResizeTextarea", AutoResizeTextarea);
};
